var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 12,
    viewBox: "0 0 10.5 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M7.5,2a.75.75,0,0,0-.671.415L6.286,3.5H3.75a.75.75,0,0,0,0,1.5v7.5A1.5,1.5,0,0,0,5.25,14h6a1.5,1.5,0,0,0,1.5-1.5V5a.75.75,0,0,0,0-1.5H10.214L9.671,2.415A.75.75,0,0,0,9,2ZM6,6.5a.75.75,0,0,1,1.5,0V11A.75.75,0,0,1,6,11Zm3.75-.75A.75.75,0,0,0,9,6.5V11a.75.75,0,0,0,1.5,0V6.5A.75.75,0,0,0,9.75,5.75Z",
    transform: "translate(-3 -2)",
    fill: "#d10000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1e0a5b84.svg";
export { ForwardRef as ReactComponent };